import { withStyles } from "@material-ui/core/styles";
import { Radio } from "@material-ui/core";
import { green, red } from "@material-ui/core/colors";
import { TextField, FormControl } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

const GreenRadio = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
    "& svg": {
      width: "1.5em",
      height: "1.5em"
    },
  },
  checked: {}
})(Radio);

const RedRadio = withStyles({
   root: {
    color: red[400],
    '&$checked': {
      color: red[600],
    },
    "& svg": {
      width: "1.5em",
      height: "1.5em"
    },
  },
  checked: {}
})(Radio);

const TextFieldStyled = withStyles({
   root: {
    '& .MuiOutlinedInput-root': {
      height: '35px',
      borderRadius: 0,
      backgroundColor:'white'
    },
    '& .MuiInputLabel-formControl': {
      top: '-18px !important'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 1px) scale(0.75)',
    },    
  },
  
  /* input:{
    '& .MuiOutlinedInput-input': {
      background: "red"
    }
  }, */

})(TextField);


const TextFieldLoginStyled = withStyles({
   root: {
    '& .MuiOutlinedInput-root': {
      height: '45px',
      borderRadius: 0,
      backgroundColor:'white'
    },
    '& .MuiInputLabel-formControl': {
      top: '-18px !important'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 1px) scale(0.75)',
    },    
  },
  
})(TextField);

const TextAreaStyled = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 0
    },
    '& .MuiInputLabel-formControl': {
      top: '-5px'
    }
  }
})(TextField);

const FormControlStyled = withStyles({
  root: {
    '& .MuiInputBase-root': {
      height: 35,
      borderRadius: 0
    },
    '& .MuiInputLabel-formControl': {
      top: '-5px'
    }
  }
})(FormControl);

const AutocompleteStyled =  withStyles({
  root: {
    '& .MuiInputBase-root': {
      height: 35,
      borderRadius: 0,     
    },
    '& .MuiInputLabel-formControl': {
      top: '-12px',
    },
    '& .MuiAutocomplete-input' :{
      padding: '3.5px 4px !important'
    }
    
  },
  input:{

  },
  option:{

  }
  //classes={{ input: 'typography-generic', option: 'typography-generic'}}

})(Autocomplete);

export { GreenRadio, RedRadio, TextFieldStyled, FormControlStyled, AutocompleteStyled, TextAreaStyled,TextFieldLoginStyled }



// WEBPACK FOOTER //
// ./src/components/common/InputStyled.js